import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { formatPlainNumber } from "../../utils/appUtils";
import { ExpenseSummaryDto } from "../../shared/dtos/expense/ExpenseSummaryDto";

interface ExpenseCardProps {
  expense: ExpenseSummaryDto;
  onView?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ExpenseCard: React.FC<ExpenseCardProps> = ({
  expense,
  onView,
}): React.JSX.Element => {
  return (
    <StyledCard sx={{ borderLeft: "4px solid", borderLeftColor: "error.main" }}>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              noWrap
              sx={{ fontWeight: "bold", color: "error.main" }}
            >
              {formatPlainNumber(expense.amount)}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", fontWeight: 600 }}
            >
              {expense.category}
            </Typography>
          </Box>
          <ReceiptIcon fontSize="small" sx={{ color: "text.secondary" }} />
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1} sx={{ flexGrow: 1 }}>
          <Typography
            variant="body2"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {expense.description}
          </Typography>
          <Typography variant="caption" color="text.disabled">
            By: {expense.processedBy}
          </Typography>
          {/* {expense.createdAt && (
            <Typography variant="caption" color="text.disabled">
              Date: {new Date(expense.createdAt).toLocaleDateString()}
            </Typography>
          )} */}
        </Stack>

        <Stack
          direction="row"
          sx={{ justifyContent: "flex-end", spacing: 0.5, mt: 1 }}
        >
          {onView && (
            <Tooltip title="View Details">
              <IconButton size="small" onClick={onView} color="info">
                <VisibilityOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default ExpenseCard;
